import React from 'react'
import PropTypes from 'prop-types'

import Text from 'components/_new/typography/Text/Text'

import s from './CardHelpItem.scss'


const CardHelpItem = (props) => {
  const { className, paymentImage, paymentName, cardImage, title } = props

  return (
    <div className={className}>
      <div className={s.header}>
        <img className={s.paymentImage} src={paymentImage} alt="" />
        <div className={s.paymentName}>{paymentName}</div>
      </div>
      <img className={s.cardImage} src={cardImage} alt="" />
      <Text
        message={title}
        size="14-24"
        align="center"
        color="gray-70"
      />
    </div>
  )
}

CardHelpItem.propTypes = {
  title: PropTypes.object,
  paymentImage: PropTypes.node,
  cardImage: PropTypes.node,
}


export default CardHelpItem
